import api from './api';

const vaulttablecolumnService = {
  // Get all vaulttablecolumns with optional filters
  getAllVaultTableColumns: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.vaulttableid) {
      params.append('vaulttableid', filters.vaulttableid);
    }

    if (filters.name) {
      params.append('name', filters.name);
    }

    const queryString = params.toString();
    const url = queryString ? `/vaulttablecolumn?${queryString}` : '/vaulttablecolumn';

    const response = await api.get(url);
    return response.data;
  },

  // Get a single vaulttablecolumn by ID
  getVaultTableColumnById: async (id) => {
    const response = await api.get(`/vaulttablecolumn/${id}`);
    return response.data;
  },

  // Create a new vaulttablecolumn
  createVaultTableColumn: async (vaulttablecolumnData) => {
    const response = await api.post('/vaulttablecolumn', vaulttablecolumnData);
    return response.data;
  },

  // Update an existing vaulttablecolumn
  updateVaultTableColumn: async (id, vaulttablecolumnData) => {
    const response = await api.put(`/vaulttablecolumn/${id}`, vaulttablecolumnData);
    return response.data;
  },

  // Delete a vaulttablecolumn
  deleteVaultTableColumn: async (id) => {
    const response = await api.delete(`/vaulttablecolumn/${id}`);
    return response.data;
  }
};

export default vaulttablecolumnService;
